// src/utilities/exports.js
import axios from 'axios';
import { formatInTimeZone } from 'date-fns-tz';
import { alertActions } from '../redux/_actions';
import { Auth } from 'aws-amplify';

export const scoresheetPDFAPI =
  'https://rnqb2biyxnvc3nnex3osqzb2hi0jqbra.lambda-url.us-west-2.on.aws/session/';

export function exportPDF(options = {}) {
  const {
    sessionId,
    sessionName,
    dispatch,
    timezone,
    combineKey,
    combineKeys,
    hideJudgeNames: noJudge,
    lineupVerification: lineupVerificationMode,
    rotationSummary: rotationSummaryMode,
    singleSheet: singleSheetOnly,
    singleTeamOfficial: singleTeamOfficialMode,
    officialScoreSheetOnlyMode,
  } = options;

  const tz = timezone ? `&tz=${encodeURIComponent(timezone)}` : '';
  const combine =
    combineKeys && combineKeys.length > 0
      ? `&combinekeys=${combineKeys.join(',')}`
      : combineKey
      ? `&combinekey=${combineKey}`
      : '';
  const hideJudge = noJudge ? '&nojudge=1' : '';
  const singleSheet = singleSheetOnly ? '&singlesheet=1' : '';
  const singleTeam = singleTeamOfficialMode ? '&singleteam=1' : '';
  const lineupVerification = lineupVerificationMode
    ? '&lineupverification=1'
    : '';
  const rotationSummary = rotationSummaryMode ? '&rotationsummary=1' : '';
  const officialOnly = officialScoreSheetOnlyMode ? '&officialonly=1' : '';

  const timestamp = formatInTimeZone(
    Date.now(),
    timezone || Intl.DateTimeFormat().resolvedOptions().timeZone,
    "M'/'dd'/'yyyy @ hh:mm:ss aaa zzz"
  );
  const fileName = `${
    sessionName || 'Scoresheet'
  } - ${sessionId} @ ${timestamp}.pdf`;

  dispatch(alertActions.notification('Generating Scoresheet PDF...', false));

  const url = `${scoresheetPDFAPI}${sessionId}/?type=team${tz}${combine}${hideJudge}${singleSheet}${singleTeam}${lineupVerification}${rotationSummary}${officialOnly}`;

  // Get Cognito token for authentication
  Auth.currentSession()
    .then((session) => {
      const idToken = session.getIdToken().getJwtToken();

      return axios({
        url,
        method: 'GET',
        responseType: 'json',
        headers: {
          Authorization: `Bearer ${idToken}`,
        },
      });
    })
    .then((response) => {
      // Response now contains a presigned S3 URL
      const { downloadUrl } = response.data;

      if (!downloadUrl) {
        throw new Error('No download URL received from server');
      }

      // Fetch the PDF blob from S3 and trigger download
      return axios({
        url: downloadUrl,
        method: 'GET',
        responseType: 'blob',
      }).then((pdfResponse) => {
        // Create blob URL and trigger download
        const urlBlob = window.URL.createObjectURL(pdfResponse.data);
        const element = document.createElement('a');
        element.setAttribute('href', urlBlob);
        element.setAttribute('download', fileName);
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
        window.URL.revokeObjectURL(urlBlob);
        dispatch(alertActions.success('Scoresheet PDF Completed.'));
      });
    })
    .catch((error) => {
      console.error('PDF Export Error:', error);

      // Check if it's an authentication error
      if (error.response?.status === 401) {
        dispatch(
          alertActions.error(
            'Authentication failed. Please log in again and try again.'
          )
        );
      } else if (error.response?.status === 403) {
        dispatch(
          alertActions.error(
            'You do not have permission to generate PDFs for this session.'
          )
        );
      } else {
        dispatch(
          alertActions.error(
            'Failed to generate PDF. Please try again or use browser print.'
          )
        );
      }
    });
}
